<val-carte>

	<div class="val-carte-dashboard-entete">
		<span class="val-carte-dashboard-titre">
			{{ titre }}
		</span>
	</div>

	<div class="val-carte-dashboard-corps">

		<val-attente-operation [visible]="chargementEnCours"></val-attente-operation>

		@if (!chargementEnCours)
		{
			@if (estEnErreur)
			{
				<span class="val-carte-dashboard-message">
					{{ messageErreur || ('dashboard.commun.erreur' | transloco) }}
				</span>
			}
			@else if (estVide)
			{
				<span class="val-carte-dashboard-message">
					{{ messageVide || ('dashboard.commun.aucune-donnee' | transloco) }}
				</span>
			}
			@else if (contenu)
			{
				<ng-container [ngTemplateOutlet]="contenu"></ng-container>
			}
		}

	</div>

</val-carte>
